<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. 웹 위변조 탐지 (WFDetector)</b></h3><br>
    <b-row style="padding-left:25px;">
      <b-col>
        <h4><b>{{start}}.1 요약</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.1.1. 기본 정보 </b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">사용자명</th>
                  <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">기간</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.2. 웹 위변조 현황</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">상태</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">합계</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">사용량</th>
                  <th class="border-bg-f1">
                    {{
                      ((wmds_summary && wmds_summary.wf_detector_stauts) ? wmds_summary.wf_detector_stauts.count : 0) +
                        ((wsfinder && wsfinder.wf_agent_list) ? wsfinder.wf_agent_list.length : 0)
                    }}
                  </th>
                </tr>
                <!-- <tr v-for="WF_5_1_2 in this.wmds_summary.wf_detector_stauts" :key="WF_5_1_2.index">
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">{{WF_5_1_2.type}}</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{WF_5_1_2.count || '0'}}</th>
                </tr> -->
              </tbody>
            </table>
            <h5><b>{{start}}.1.3. 탐지 이벤트 현황</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">이벤트</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">합계</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">
                    WMDS Domain
                  </th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wmds_summary && wmds_summary.wf_total_number_of_security_events ? wmds_summary.wf_total_number_of_security_events.count :  0) | number}}
                  </th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">
                    WSFinder Server
                  </th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wsfinder ? wsfinder.total_forgery : 0) | number}}
                  </th>
                </tr>
              </tbody>
            </table>
            <h5>
              <b>
                {{start}}.1.4. 웹 서버 & 웹 위변조 현황
                <small class="float-right">최근 10개</small>
              </b>
            </h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <td class="table-f1" style="width:40%" colspan="3">WSFinder 서버</td>
                </tr>
                <tr>
                  <td class="table-f1">이름</td>
                  <td class="table-f1">Host</td>
                  <td class="table-f1">IP</td>
                </tr>
                <tr v-if="wsfinder && wsfinder.wf_agent_list && wsfinder.wf_agent_list.length" v-for="WF_5_1_4 in wsfinder.wf_agent_list" :key="WF_5_1_4.index">
                  <td class="border-f1">{{WF_5_1_4.name}}</td>
                  <td class="border-f1">{{WF_5_1_4.host}}</td>
                  <td class="border-f1">{{WF_5_1_4.ip_addr_public}} / {{WF_5_1_4.ip_addr_private}}</td>
                </tr>
                <tr v-if="!(wsfinder && wsfinder.wf_agent_list && wsfinder.wf_agent_list.length)">
                  <td class="border-f1">N/A</td>
                  <td class="border-f1">N/A</td>
                  <td class="border-f1">N/A</td>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.5. 웹 도메인 & 위변조 현황 </b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <td class="table-f1" style="width:40%" colspan="3">WMDS 도메인</td>
                </tr>
                <tr>
                  <td class="table-f1">이름</td>
                  <td class="table-f1">FQDN</td>
                </tr>
                <tr v-for="WF_5_1_5 in wmds_summary.domain_and_wf_detector_status" :key="WF_5_1_5.index">
                  <td class="border-f1">{{WF_5_1_5.name}}</td>
                  <td class="border-f1">{{WF_5_1_5.fqdn}}</td>
                </tr>
                <tr v-if="wmds_summary.domain_and_wf_detector_status.length < 1">
                  <td class="border-f1">N/A</td>
                  <td class="border-f1">N/A</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <h4><b>{{start}}.2 모니터링 현황</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.2.1. 일별 탐지 이벤트 현황</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.1.1. 일별 탐지 (Total)</b></h5>
                <lineChart :chartData="WF_Daily_Detect_Total" :options="WF_Daily_Detect_Total.options" />
              </b-col>
            </b-row>
            <hr>
            <!-- 사이트별 또는 서버별 -->
            <h5><b>{{start}}.2.2. 일별 탐지</b></h5>
            <b-row style="padding-left:25px;" v-for="(WF_5_2_2, wmds_wf_index) in WF_Daily_detect_domain" :key="WF_5_2_2.index">
              <b-col>
                <h5><b>{{start}}.2.2.{{wmds_wf_index + 1}} 도메인 일별 탐지 ({{WF_5_2_2.fqdn}})</b></h5>
                <lineChart :chartData="WF_5_2_2.chart" :options="WF_5_2_2.options" />
              </b-col>
            </b-row>
            <!-- <hr v-if="WF_Daily_detect_server.length > 0"> -->
            <b-row style="padding-left:25px;" v-for="(WF_5_2_3, wsf_wf_index) in WF_Daily_detect_server" :key="WF_5_2_3.index">
              <b-col>
                <h5><b>{{start}}.2.2.{{wsf_wf_index +  (WF_Daily_detect_domain && WF_Daily_detect_domain.length ? WF_Daily_detect_domain.length : 0) + 1}} 서버 일별 탐지 ({{WF_5_2_3.host}})</b></h5>
                <lineChart :chartData="WF_5_2_3.chart" :options="WF_5_2_3.options" />
              </b-col>
            </b-row>
            <b-row style="padding-left:25px;" v-if="WF_Daily_detect_server && WF_Daily_detect_server.length < 1 && WF_Daily_detect_domain && WF_Daily_detect_domain.length < 1">
              <b-col>
              <lineChart  :chartData="DEFAULT_CHART_DATA" />
              </b-col>
            </b-row>
            <hr>
            <h5><b>{{start}}.2.3. 도메인/서버 탐지 요약 </b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.3.1. 도메인/서버 탐지 현황 </b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr class="table-f1">
                      <td class="table-f1" rowspan="2">도메인 / 서버</td>
                      <td class="table-f1">이벤트</td>
                    </tr>
                      <tr class="table-f1">
                      <td class="table-f1">탐지</td>
                    </tr>
                    <!-- wmds -->
                    <tr class="border-f1" v-for="WF_5_2_3_1 in wmds_summary.wf_total_number_per_domain" :key="WF_5_2_3_1.index">
                      <td class="border-f1">{{WF_5_2_3_1.fqdn}}</td>
                      <td class="border-f1">{{WF_5_2_3_1.count ? WF_5_2_3_1.count : 0}}</td>
                    </tr>
                    <!-- wsfinder -->
                    <tr v-if="wsfinder" class="border-f1" v-for="WF_5_2_3_1 in wsfinder.wf_agent_list" :key="WF_5_2_3_1.index">
                      <td class="border-f1">{{WF_5_2_3_1.name}}</td>
                      <td class="border-f1">{{WF_5_2_3_1.total_forgery ? WF_5_2_3_1.total_forgery : 0}}</td>
                    </tr>
                    <tr class="border-f1"
                      v-if="wsfinder && wsfinder.wf_agent_list && wmds_summary.wf_total_number_per_domain.length < 1 && wsfinder && (!wsfinder.wf_agent_list || wsfinder.wf_agent_list.length < 1)"
                    >
                      <td class="border-f1">N/A</td>
                      <td class="border-f1">N/A</td>
                    </tr>
                  </tbody>
                </table>
                <!-- TODO : 2022.08 버전에서 작업 예정 -->
                <!-- <h5><b>{{start}}.2.3.2. 이벤트 (Total) <small class="float-right">최근 10개</small></b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr class="table-f1">
                      <td class="table-f1">이름</td>
                      <td class="table-f1">구분</td>
                      <td class="table-f1">패턴</td>
                      <td class="table-f1">경로</td>
                      <td class="table-f1">탐지 시각</td>
                    </tr>
                    <tr v-if="wsfinder && wsfinder.wf_total_detection" v-for="WF_5_2_3_2 in wsfinder.agent_daily_stats" :key="WF_5_2_3_2.index">
                      <td class="border-f1">{{WF_5_2_3_2.name}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.type}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.action}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.target}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.created_at | date}}</td>
                    </tr>
                    <tr v-if="wmds_summary.wf_total_detection" v-for="WF_5_2_3_2 in wmds_summary.wf_total_detection" :key="WF_5_2_3_2.index">
                      <td class="border-f1">{{WF_5_2_3_2.name}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.type}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.action == '-' ? 'change' : WF_5_2_3_2.action}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.target}}</td>
                      <td class="border-f1">{{WF_5_2_3_2.created_at | date}}</td>
                    </tr>
                    <tr class="border-f1"
                      v-if="!wsfinder && wsfinder.wf_total_detection.length < 1 && !wmds_summary && wmds_summary.wf_total_detection.length < 1"
                    >
                      <td class="border-f1">N/A</td>
                      <td class="border-f1">N/A</td>
                      <td class="border-f1">N/A</td>
                      <td class="border-f1">N/A</td>
                      <td collapse="2" class="border-f1">N/A</td>
                    </tr>
                  </tbody>
                </table> -->
                <!-- WMDS -->
                <!-- <div v-for="(WF_5_2_3_3, index) in wmds_summary.wf_events_domain" :key="WF_5_2_3_3.index">
                  <h5><b>{{start}}.2.3.{{index + 3}} 이벤트 ({{WF_5_2_3_3.fqdn}}) <small class="float-right">최근 10개</small></b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                        <tr>
                          <td class="table-f1">이름</td>
                          <td class="table-f1">구분</td>
                          <td class="table-f1">액션</td>
                          <td class="table-f1">대상</td>
                          <td class="table-f1">탐지 시각</td>
                        </tr>
                        <tr v-for="WF_5_2_3_3_1 in WF_5_2_3_3.rs_list" :key="WF_5_2_3_3_1.index">
                          <td class="border-f1">{{WF_5_2_3_3_1.name}}</td>
                          <td class="border-f1">{{WF_5_2_3_3_1.type}}</td>
                          <td class="border-f1">{{WF_5_2_3_3_1.action ? '변경' : '변경'}}</td>
                          <td class="border-f1">{{WF_5_2_3_3_1.target}}</td>
                          <td class="border-f1">{{WF_5_2_3_3_1.created_at | date}}</td>
                        </tr>
                    </tbody>
                  </table>
                </div> -->
                <!-- wsfinder -->
                <!-- <div v-for="(WF_5_2_3_4, index) in wsfinder.wf_events_server" :key="WF_5_2_3_4.index">
                  <h5><b>{{start}}.2.3.{{wmds_summary.wf_events_domain.length + index + 3}} 이벤트 ({{WF_5_2_3_4.host}}) <small class="float-right">최근 10개</small></b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                        <tr>
                          <td class="table-f1">이름</td>
                          <td class="table-f1">구분</td>
                          <td class="table-f1">액션</td>
                          <td class="table-f1">대상</td>
                          <td class="table-f1">탐지 시각</td>
                        </tr>
                        <tr v-for="WF_5_2_3_4_1 in WF_5_2_3_4.rs_list" :key="WF_5_2_3_4_1.index">
                          <td class="border-f1">{{WF_5_2_3_4_1.name}}</td>
                          <td class="border-f1">{{WF_5_2_3_4_1.type}}</td>
                          <td class="border-f1">{{WF_5_2_3_4_1.action}}</td>
                          <td class="border-f1">{{WF_5_2_3_4_1.target}}</td>
                          <td class="border-f1">{{WF_5_2_3_4_1.created_at | date}}</td>
                        </tr>
                        <tr class="border-f1" v-if="WF_5_2_3_4.rs_list.length < 1">
                          <td class="border-f1">N/A</td>
                          <td class="border-f1">N/A</td>
                          <td class="border-f1">N/A</td>
                          <td class="border-f1">N/A</td>
                          <td class="border-f1">N/A</td>
                        </tr>
                    </tbody>
                  </table>
                </div> -->
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!-- <h4><b>4.3 Response Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>4.3.1. Incident Response</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>4.3.1.1. Alert sending status</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th class="table-f1" style="width:40%"></th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detection E-mail</th>
                    </tr>
                    <tr>
                      <th class="border-bg-f1">Alert</th>
                      <th class="border-bg-f1">{{`60`}}</th>
                    </tr>
                  </tbody>
                </table>
                <h5><b>4.3.1.2. Daily detection Alert</b></h5>
                <lineChart :chartData="this.chartData" />
              </b-col>
            </b-row>
          </b-col>
        </b-row> -->
        </b-col>
      </b-row>
    </b-col>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';

export default {
  name:'ReportWebCastle',
  props: [
    'start',
    'end',
    'from',
    'to',
    'wsfinder',
    'wmds_summary',
    'WF_Daily_Detect_Total',
    'WF_Daily_detect_domain',
    'WF_Daily_detect_server',
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      custom : Custom.custom_default,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // custom
    get_doughnut_data: function(severity) {
      let doughnut_data = { labels: [], datasets: [ { label: 'Risk analysis', backgroundColor: [], data: [] } ] }
      _.sortBy(severity, s => s.total).forEach(x => {
        doughnut_data.labels.push(codes.WAF_SEVERITY_TO_DESC(x.severity))
        doughnut_data.datasets[0].data.push(x.total)
        doughnut_data.datasets[0].backgroundColor.push(codes.WAF_SEVERITY_TO_COLOR(x.severity))
      })
      return doughnut_data
    },
    // 넘버링
  },
  created: function() {
    console.log(`[${this.custom.slogan}]Report.wfdetect.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}]Report.wfdetect.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}]Report.wfdetect.vue`, `mounted`);
  },
}
</script>
